@let disabled = disabled$ | async;
@let disabledOrValidating = disabled || validating$();
<app-control-wrapper
  [control]="control"
  [officeField]="officeField"
  [formGroupInstance]="formGroupInstance"
  [errorsMessagesOverridesRegistry]="errorsMessagesOverridesRegistry"
  [required]="control | controlHasRequired"
  [validating]="validating$()"
  [disabled]="disabledOrValidating"
  [touched]="isTouched$ | async"
  [dirty]="isDirty$ | async"
  [alignment]="alignment"
  [config]="config">
  <div
    class="w-100 app-image-upload"
    [ngClass]="{
      'app-image-upload--disabled': disabledOrValidating,
    }">
    @if (!imageUrl$()) {
      <div class="file-drop-zone w-100 app-image-upload__drop-zone" (click)="fileInput.click()">
        <div
          class="my-5 text-center text-primary"
          [ngClass]="{
            'text-secondary': disabledOrValidating,
          }">
          Drag and Drop or Click
          <input #fileInput type="file" [accept]="allowedFileTypes" (change)="onFileSelected($event)" hidden />
        </div>
      </div>
    } @else {
      <div class="preview w-100 d-flex">
        <div>
          <img [src]="imageUrl$()" alt="Preview" />
        </div>
        <div class="flex-grow-1">
          <div class="d-flex justify-content-end">
            <button type="button" appButton="primary" [disabled]="disabledOrValidating || !fileOrigin$()" (click)="onUpload(); (false)">
              Upload
            </button>
            <button type="button" appButton="danger" [disabled]="disabledOrValidating" (click)="onRemove(); (false)">Remove</button>
          </div>
        </div>
      </div>
    }
  </div>
</app-control-wrapper>
